// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {getVsrMessage, hasVsrErrorForClaimField, isNotEmpty} from '../../../../shared/services/claim-shared-helper';
import ClaimMaintenancePlan from '@deere/cps-it.warranty-model-factory/lib/claim-maintenance-plan';
import FormValidation from '../../state/form-validation';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import LabeledCheckbox from '../../../../shared/components/claim-fields/labeled-checkbox';
import LabeledKeyValueDropDown from '../../../../shared/components/claim-fields/labeled-key-value-dropdown';
import LabeledPlanNameDropDown from '../../../../shared/components/claim-fields/labeled-plan-name-dropdown';
import LabeledTextArea from '../../../../shared/components/claim-fields/labeled-text-area';
import LabeledTextAreaWithBlur from '../../../../shared/components/claim-fields/labeled-text-area-with-blur';
import OpenMaintenancePlan from '@deere/cps-it.warranty-model-factory/lib/open-maintenance-plan';

function handleDropDownBlur(property, event) {

    this.actions.updateFormValidation(property, event.target.value);

}

function handlePlanNameChange(event) {

    this.actions.updatePlanName(event.target.value, this.openMaintenancePlans);
    this.actions.readOpenServiceIntervals(event.target.value, this.claim);

}

function handleServiceIntervalChange(event) {

    this.actions.updateServiceInterval(event.target.value, this.openServiceIntervals);

}

function handleMachineTypeChange(event) {

    this.actions.updateMachineType(event.target.value, this.selectedOpenMaintenancePlan.machineTypes);

}

function handleNoTravelChange(noTravel) {

    this.actions.updateNoTravel(noTravel);

}

const getNoTravelValueToShow = noTravel =>
    noTravel ? 'YES_LOWERCASE' : 'NO_LOWERCASE';

function handleInputBlur(property, value) {

    this.actions.updateFormValidation(property, value);

}

function handleCommentsChange(comments) {

    this.actions.updateComments(comments);

}

function handleAdditionalCommentsChange(additionalComments) {

    this.actions.updateAdditionalComments(additionalComments);

}

const MaintenancePlanInfoContainer = props =>
    <div className='maintenance-plan-info-container'>
        <div className='maintenance-plan-info'>
            <h3>
                <FormattedMessage id='MAINTENANCE_PLAN_INFO'/>
            </h3>
            <div className='data-row'>
                <LabeledPlanNameDropDown
                    className='plan-name'
                    errorMessage='PLAN_NAME_IS_REQUIRED'
                    highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'planName', props.isEditable)}
                    isEditable={props.isEditable}
                    isValid={props.formValidation.planName}
                    label='PLAN_NAME'
                    list={props.openMaintenancePlans}
                    onBlur={handleDropDownBlur.bind(props, 'planName')}
                    onChange={props::handlePlanNameChange}
                    selectedValue={props.selectedOpenMaintenancePlan}
                    vsrMessage={getVsrMessage(props.claim.errors, 'planName', props.isEditable)}
                />
            </div>
            <div className='data-row'>
                <LabeledKeyValueDropDown
                    className='service-interval'
                    errorMessage='SERVICE_INTERVAL_IS_REQUIRED'
                    highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'serviceInterval', props.isEditable)}
                    isEditable={props.isEditable}
                    isValid={props.formValidation.serviceInterval}
                    label='SERVICE_INTERVAL'
                    list={props.openServiceIntervals}
                    onBlur={handleDropDownBlur.bind(props, 'serviceInterval')}
                    onChange={props::handleServiceIntervalChange}
                    selectedValue={props.claim.serviceInterval}
                    vsrMessage={getVsrMessage(props.claim.errors, 'serviceInterval', props.isEditable)}
                />
            </div>
            <div className='data-row'>
                {props.selectedOpenMaintenancePlan.showMachineType &&
                    <LabeledKeyValueDropDown
                        className='machine-type'
                        errorMessage='MACHINE_TYPE_IS_REQUIRED'
                        highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'machineType', props.isEditable)}
                        isEditable={props.isEditable}
                        isValid={props.formValidation.machineType}
                        label='MACHINE_TYPE'
                        list={props.selectedOpenMaintenancePlan.machineTypes}
                        onBlur={handleDropDownBlur.bind(props, 'machineType')}
                        onChange={props::handleMachineTypeChange}
                        selectedValue={props.claim.machineType}
                        vsrMessage={getVsrMessage(props.claim.errors, 'machineType', props.isEditable)}
                    />
                }
                {props.selectedOpenMaintenancePlan.showNoTravel &&
                    <LabeledCheckbox
                        className='no-travel'
                        id='NO-TRAVEL'
                        isEditable={props.isEditable}
                        isSelected={props.claim.noTravel}
                        label='NO_TRAVEL'
                        onChange={props::handleNoTravelChange}
                        translationId={getNoTravelValueToShow(props.claim.noTravel)}
                    />
                }
            </div>
            {isNotEmpty(props.claim.comments) &&
                <div className='data-row'>
                    <LabeledTextAreaWithBlur
                        className='comments'
                        disabled={true}
                        errorMessage='COMMENTS_IS_REQUIRED'
                        highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'comments', props.isEditable)}
                        isEditable={props.isEditable}
                        isValid={props.formValidation.comments}
                        label='COMMENTS'
                        onBlur={handleInputBlur.bind(props, 'comments')}
                        onChange={props::handleCommentsChange}
                        value={props.claim.comments}
                        vsrMessage={getVsrMessage(props.claim.errors, 'comments', props.isEditable)}
                    />
                </div>
            }
            {props.selectedOpenMaintenancePlan.showAdditionalComments &&
                <div className='data-row'>
                    <LabeledTextArea
                        className='additional-comments'
                        highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'additionalComments', props.isEditable)}
                        isEditable={props.isEditable}
                        label='ADDITIONAL_COMMENTS'
                        onChange={props::handleAdditionalCommentsChange}
                        value={props.claim.additionalComments}
                        vsrMessage={getVsrMessage(props.claim.errors, 'additionalComments', props.isEditable)}
                    />
                </div>
            }
        </div>
    </div>;

MaintenancePlanInfoContainer.displayName = 'MaintenancePlanInfoContainer';
MaintenancePlanInfoContainer.propTypes = {
    actions: PropTypes.object.isRequired,
    claim: PropTypes.instanceOf(ClaimMaintenancePlan).isRequired,
    formValidation: PropTypes.instanceOf(FormValidation).isRequired,
    isEditable: PropTypes.bool.isRequired,
    openMaintenancePlans: PropTypes.arrayOf(PropTypes.instanceOf(OpenMaintenancePlan)).isRequired,
    openServiceIntervals: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    selectedOpenMaintenancePlan: PropTypes.instanceOf(OpenMaintenancePlan).isRequired
};

export default MaintenancePlanInfoContainer;



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/components/maintenance-plan-info/maintenance-plan-info-container.js